export default {
  collapse: "Collapse",
  expand: "Expand"
};
